import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Wizard } from './Wizard';

ReactDOM.render(
  <StrictMode>
    <Wizard />
  </StrictMode>,
  document.getElementById('root'),
);
